"use client";

import { Button } from "@/components/actions/Button";
import If from "@/components/common/If";
import { useNav } from "@/providers/Nav";

export default function Nav() {
  const { navRetracted } = useNav();
  return (
    <nav
      className={`sticky transition-all duration-300 ease-in-out ${navRetracted ? "top-0" : "top-[80px]"} z-[15000] bg-white py-6`}
    >
      <div className="contianer mx-auto flex justify-start md:justify-center gap-8 items-center overflow-auto px-gutter">
        <div className="relative inline-block w-max">
          <select
            className="block appearance-none h-[48px] w-max  max-w-[200px] bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 leading-tight focus:outline-none focus:shadow-outline"
            onChange={(e) =>
              e.target.value && (window.location.href = e.target.value)
            }
          >
            <option>Available Products</option>
            <optgroup label="Aspiro® Series" className="font-bold">
              <option value="/products/select-wood-veneer">
                Select Wood Veneer
              </option>
              <option value="/products/premium-painted">
                Premium Paintable
              </option>
              <option value="/products/choice-laminates">
                Choice Laminates
              </option>
              <option value="/products/stile-and-rail">
                Stile {"&"}" Rail
              </option>
              <option value="/products/aspiro-defendr-door-system">
                Aspiro Series Defendr™ Door System
              </option>
            </optgroup>
            <optgroup label="Cendura® Series" className="font-bold">
              <option value="/products/standard-wood-veneer">
                Standard Wood Veneer
              </option>
              <option value="/products/standard-paintable">
                Standard Paintable
              </option>
              <option value="/products/everyday-laminates-hpdl">
                Everyday Laminates
              </option>
            </optgroup>
          </select>
          {/* <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div> */}
        </div>
        <Button
          href="/technical-resources"
          variant="secondary"
          isLight
          size="small"
        >
          Resources
        </Button>
        <Button href="/samples" variant="secondary" isLight size="small">
          Order Samples
        </Button>
        <Button href="/contact-us" variant="secondary" isLight size="small">
          Contact Us
        </Button>
      </div>
    </nav>
  );
}
